import { render, staticRenderFns } from "./ToolsHandbook.vue?vue&type=template&id=4c0dd8fc"
import script from "./ToolsHandbook.vue?vue&type=script&lang=js"
export * from "./ToolsHandbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports